export default {
    nav: {
        assets: "Asset Center",
        benefits: "All Benefits",
        code: "Gift Card",
    },
    benefits: {
        money: "Money",
        k_coin: "K Coin Balance",
        points: "Points",
        level: "Level",
        coin: "Coin",
        exp: "Experience",
        recharge: "Recharge Now",
        points_history: "Points Change Records",
        exp_history: "Level Growth Records",
        opened_service: "Opened Services",
        expired_at: "Expires",
        renew: "Renew Now",
        reopen: "Reopen",
        no_service: "No services available",
        kind: "Type",
        change_count: "Change Count",
        created_at: "Created At",
        kind_map: {
            exp: "Experience",
            points: "Points",
            vip0001: "Level",
            k_coin: "K Coin",
            o_coin: "O Coin",
            g_coin: "G Coin",
        },
    },
    level: {
        1: "Bronze",
        2: "Silver",
        3: "Gold",
        4: "Platinum",
        5: "Diamond",
        6: "Black Diamond",
        7: "Prestige",
        8: "Supreme",
    },
    purchase: {
        upgrade_account: "Upgrade Your Account",
        upgrade_account_en: "Upgrade your account",
        select_package: "Select Specification",
        selected: "Selected",
        pay_immediately: "Pay Now",
        original_price: "Original Price",
        discount: "Discount",
        total_discount: "Saved",
        unit: "RMB",
        off: " Off",
        no_discount: "No Discount",
        agreement_tip1: "Virtual items are non-refundable",
        agreement_tip2: "Benefits gained are based on the actual payment amount",
        total: "Total",
    },
    voucher: {
        all: "All",
        unused: "Unused",
        used: "Used",
        expired: "Expired",
        exchanged: "Exchanged",
        unexchanged: "Unexchanged",
        unusedCount: "Available",
        totalCount: "Total",
        expiryDate: "Expires on",
        hideContent: "Hide content",
        showContent: "Show content",
        copied: "Copied",
        copy: "Copy",
        supportTitle: "Redemption issues?",
        supportDesc: "If your activation code cannot be used, please contact support or check the FAQ.",
        contactSupport: "Contact Support",
        passwordPromptMsg: "Please enter your security password to view the code",
        passwordPromptTitle: "Security Verification",
        passwordPlaceholder: "Enter password",
        passwordRequired: "Password is required",
        tokenError: "Failed to get security token",
        authFailed: "Authentication failed",
        decryptFailed: "Decryption failed, please try again",
        tokenExpired: "Security token expired, please re-verify",
        fetchError: "Failed to fetch activation code",
    },
};
